import commonService from './commonService'
import utils from './utils'
import axios from './axios'

const get = async (id, signal = null) => {
  const url = `${utils.url}/voting_centers/${id}`
  return await commonService.load(url, signal, null)
}

const getAll = async () => {
  const url = utils.url + '/voting_centers'
  const res = await axios.get(url)
  return res.data
}

const getAllFromso = async (offset, limit, signal = null) => {
  const url = `${utils.url}/voting_centers/fromso/${offset}-${limit}`
  return await commonService.load(url, signal, [])
}

const add = async (instance, signal = null) => {
  return await commonService.add('voting_centers', instance, signal)
}

const update = async (instance, signal = null) => {
  return await commonService.update('voting_centers', instance, signal)
}

const delete_ = async (instance, signal = null) => {
  return await commonService.delete_('voting_centers', instance.id, signal)
}

const getAllByProvince = async (provinceId, signal = null) => {
  const url = `${utils.url}/provinces/${provinceId}/voting_centers`
  return await commonService.load(url, signal, [])
}

const getAllByProvinceAndMandate = async (provinceId, mandateId, signal = null) => {
  const url = `${utils.url}/voting_centers/by/province/${provinceId}/${mandateId}`
  return await commonService.load(url, signal, [])
}

const getAllByTerritory = async (territoryId, signal = null) => {
  const url = `${utils.url}/territories/${territoryId}/voting_centers`
  return await commonService.load(url, signal, [])
}

const getAllBySector = async (sectorId, signal = null) => {
  const url = `${utils.url}/sectors/${sectorId}/voting_centers`
  return await commonService.load(url, signal, [])
}

const count = async (signal = null) => {
  const url = `${utils.url}/voting_centers/count`
  return await commonService.load(url, signal, 0)
}

const getResume = async (mandateId, provinceId = null, signal = null) => {
  const url = provinceId
    ? `${utils.url}/voting_centers/resume/by/province/${mandateId}/${provinceId}`
    : `${utils.url}/voting_centers/resume/by/mandate/${mandateId}`
  return await commonService.load(url, signal, 0)
}

export default {
  getAll,
  getAllByProvinceAndMandate,
  getAllByProvince,
  getAllByTerritory,
  getAllBySector,
  getAllFromso,
  get,
  add,
  update,
  delete_,
  count,
  getResume,
}
